module.exports = __webpack_public_path__ + "static/logo-florette-c635e164ff125b3e79eee35218d12bd4.png";